// src/redux/sentiment/sentimentSlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchStockSentimentAggsThunk,
  fetchStockSentimentAggsBatchThunk,
} from "./sentimentAggActionThunks";

const initialState = {
  byTicker: {}, // { [ticker]: { timeframe: { data, status } } }
  loading: false,
  error: null,
};

const sentimentAggsSlice = createSlice({
  name: "sentiment",
  initialState,
  reducers: {
    resetSentimentState: (state) => {
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockSentimentAggsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockSentimentAggsThunk.fulfilled, (state, { payload }) => {
        const { ticker, timeframe, data } = payload;
        if (!state.byTicker[ticker]) {
          state.byTicker[ticker] = {};
        }
        state.byTicker[ticker][timeframe] = {
          data,
          status: "ready",
        };
        state.loading = false;
      })
      .addCase(fetchStockSentimentAggsThunk.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(fetchStockSentimentAggsBatchThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockSentimentAggsBatchThunk.fulfilled, (state, { payload }) => {
        const { timeframe, data } = payload;
        for (const [ticker, tickerData] of Object.entries(data || {})) {
          if (!state.byTicker[ticker]) {
            state.byTicker[ticker] = {};
          }
          state.byTicker[ticker][timeframe] = {
            data: tickerData,
            status: "ready",
          };
        }
        state.loading = false;
      })
      .addCase(fetchStockSentimentAggsBatchThunk.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      });
  },
});

export const { resetSentimentState } = sentimentAggsSlice.actions;
export default sentimentAggsSlice.reducer;

// --- Fixed Selectors ---
export const selectSentimentByTicker = (state, ticker, timeframe = "all") => {
  if (!state?.sentimentAgg?.byTicker || !ticker) {
    return null;
  }
  return state.sentimentAgg.byTicker[ticker]?.[timeframe]?.data || null;
};

export const selectSentimentStatus = (state, ticker, timeframe = "all") => {
  if (!state?.sentimentAgg?.byTicker || !ticker) {
    return "unknown";
  }
  return state.sentimentAgg.byTicker[ticker]?.[timeframe]?.status || "unknown";
};

export const selectSentimentLoading = (state) =>
  state?.sentimentAgg?.loading || false;

export const selectSentimentError = (state) =>
  state?.sentimentAgg?.error || null;